import { LabFeatureFlags } from 'constants/lab'
import { isLabSiteTakeoverPayload, TakeoverId } from 'lib/lab/dynamicPayload'
import { createSelector } from 'reselect'
import { TASTE_OF_GOLD_CAMPAIGN_BENEFIT } from '../constants/tasteOfGoldConstants'

const getTasteOfGoldPromoCampaign = createSelector(
  (state: App.State) => state.system.features.labFlags[LabFeatureFlags.enableSiteTakeover],
  (state: App.State) => state.loyalty.promoCampaigns,
  (state: App.State) => state.geo.currentRegionCode,
  (flag, promoCampaigns, regionCode): App.LoyaltyPromoCampaign | undefined => {
    if (regionCode !== 'AU') return undefined
    const isTakeoverEnabled = !!flag?.enabled && isLabSiteTakeoverPayload(flag.value) && flag.value.id === TakeoverId.TASTE_OF_GOLD_TAKEOVER
    if (!isTakeoverEnabled) return undefined
    return promoCampaigns.find(
      campaign => campaign.benefit === TASTE_OF_GOLD_CAMPAIGN_BENEFIT,
    )
  },
)

export default getTasteOfGoldPromoCampaign
